import { NgModule } from '@angular/core'
import { PhoneFormatDirective } from './phone-format.directive'
import { CurrencyInputDirective } from './currency-input.directive'
import { CapitalizeFirstDirective } from './capitalize-first.directive'

@NgModule({
    declarations: [PhoneFormatDirective, CurrencyInputDirective, CapitalizeFirstDirective],
    exports: [PhoneFormatDirective, CurrencyInputDirective, CapitalizeFirstDirective],
})
export class DirectivesModule {}
